import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/api";

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = anon, object = admin

  useEffect(() => {
    adminApi.get("/admin/auth/me").then((r) => setAdmin(r.data)).catch(() => setAdmin(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/auth/login", { email, password });
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = async () => {
    await adminApi.post("/admin/auth/logout").catch(() => {});
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
